import { z } from 'zod';

import type { FixedIdAssetRegistryItem, FixedIdAssetSnapshot } from './fixed-id-assets.dto.js';
import {
  fixedIdAssetAvailabilityReasonValues,
  fixedIdAssetStateValues,
} from './fixed-id-assets.dto.js';
import {
  HoldingUnitContainerKindSchema,
  HoldingUnitIdentityModeSchema,
  HoldingUnitLifecycleStatusSchema,
  HoldingUnitReservationTargetTypeSchema,
} from './holding-units.schema.js';

const timestampSchema = z.iso.datetime();

export const FixedIdAssetStateSchema = z.enum(fixedIdAssetStateValues);
export const FixedIdAssetAvailabilityReasonSchema = z.enum(fixedIdAssetAvailabilityReasonValues);

const FixedIdAssetSnapshotObjectSchema = z.object({
  id: z.uuid(),
  companyId: z.uuid(),
  homeStoreId: z.uuid(),
  homeLocationId: z.uuid(),
  lastKnownStoreId: z.uuid(),
  lastKnownLocationId: z.uuid(),
  lastKnownYardLocationId: z.uuid().nullable(),
  identityMode: HoldingUnitIdentityModeSchema.extract(['fixed_asset_cycle']),
  containerKind: HoldingUnitContainerKindSchema.extract(['heavy_container']),
  physicalId: z.string().trim().min(1).max(64),
  normalizedPhysicalId: z.string().trim().min(1).max(64),
  normalizedScannableIdentifier: z.string().trim().min(1).max(64),
  masterTareLb: z.number().nonnegative(),
  state: FixedIdAssetStateSchema,
  activeCycleUnitId: z.uuid().nullable(),
  version: z.number().int().nonnegative(),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const FixedIdAssetSnapshotSchema: z.ZodType<FixedIdAssetSnapshot> =
  FixedIdAssetSnapshotObjectSchema;

export const FixedIdAssetRegistryItemSchema: z.ZodType<FixedIdAssetRegistryItem> =
  FixedIdAssetSnapshotObjectSchema.extend({
    activeCycleLifecycleStatus: HoldingUnitLifecycleStatusSchema.extract([
      'open',
      'ready',
    ]).nullable(),
    isAvailable: z.boolean(),
    unavailableReason: FixedIdAssetAvailabilityReasonSchema,
    unitId: z.uuid().nullable().optional(),
    lifecycleStatus: HoldingUnitLifecycleStatusSchema.nullable().optional(),
    reservationType: HoldingUnitReservationTargetTypeSchema.nullable().optional(),
    loadSessionId: z.uuid().nullable().optional(),
    shipmentId: z.uuid().nullable().optional(),
  }).strict();
